import { render, staticRenderFns } from "./PassengerInfo.vue?vue&type=template&id=60ad6429"
import script from "./PassengerInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./PassengerInfo.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports